// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3QW2f","footer":"ReportModalFilter_footer__twL9r"};